import { render, staticRenderFns } from "./contract-record-difference.vue?vue&type=template&id=200763a2&scoped=true&"
import script from "./contract-record-difference.vue?vue&type=script&lang=js&"
export * from "./contract-record-difference.vue?vue&type=script&lang=js&"
import style0 from "./contract-record-difference.vue?vue&type=style&index=0&id=200763a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200763a2",
  null
  
)

export default component.exports